<template>

    <!-- 内容区域 -->
     <div>
    <EmployeeProgressbar :currentStep="1" :tenantId="tenantId"/>
    <div class="dashboard-tab">

      <h3 class="tab-title">知识库管理</h3>
      <div class="tips-container">
      <img src="@/assets/images/agent02.png" class="agent-img" alt="AI客服专员"/>
      <a class="info-text" v-if="kbWorkspaces.length==0">您没有负责维护的知识库，请联系管理员分配吧~</a>
      <a class="info-text" v-else>您负责维护{{ kbWorkspaces.length }}个知识库</a>
     </div>

      <el-table
      v-if="kbWorkspaces.length>0"
        :data="kbWorkspaces"
        style="width: 100%"
        class="custom-table"
        header-row-class-name="custom-header"
        row-class-name="custom-row"  v-loading="loading">
        <el-table-column prop="name" label="名称" width="180" align="center"></el-table-column>
        <el-table-column prop="documentCount" label="已上传文档数量" width="150" align="center"></el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="180" align="center">
  <template #default="scope">
    {{ formatDate(scope.row.createdAt) }}
  </template>
</el-table-column>
        <el-table-column prop="action" label="操作" align="center">
          <template #default="scope">
            <el-button
              @click="HandleSetting(scope.row)"
              type="text"
              size="small" icon="el-icon-setting">
              知识库配置
            </el-button>
            <el-button
              @click="HandleDocument(scope.row)"
              type="text"
              size="small" icon="el-icon-close">
              文档管理
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="empty-container" v-if="kbWorkspaces.length==0">
      <img alt="暂无数据" src="@/assets/images/empty.png" class="empty-img" />
      <p class="empty-text">这里空空如也</p>
</div>

    <!-- 配置对话框 -->
    <el-dialog :title="title_setting" :visible.sync="open_setting" width="750px" append-to-body>
<KbWorkspaceSetting v-if="open_setting"
:slug="currentSlug"
ref="settingComponent"
@submit-success="handleSettingSubmit"
/>
<div slot="footer" class="dialog-footer">
  <el-button type="primary" @click="submitForm_settings">确 定</el-button>
  <el-button type="plain" @click="cancel_setting">取 消</el-button>
</div>
</el-dialog>
    </div>
     </div>
</template>

<script>
import { listKbWorkspaces_by_tenantId_username,  } from '@/api/aics/kbWorkspace';
import EmployeeProgressbar from '@/components/employee/progress-bar.vue'; //进度条组件
import KbWorkspaceSetting from '@/components/kb_workspace/setting.vue';
import {formatDate } from '@/util/date';

export default {
   name: "EmployeeKbWorkspace",
   components: {
    EmployeeProgressbar,
    KbWorkspaceSetting
   },
   data() {
     return {
      kbWorkspaces: [],
        employee_count: 0,
        workspace_count: 0,
        document_count: 0,
        aics_center_count: 0,
        aics_seat_count: 0,
        loading: false, // 新增loading状态
        title_setting: '', // 弹窗标题
        open_setting: false, // 弹窗状态
        form_setting: {
        name: '',
        serviceTo: '',
      },
      currentSlug: '',
        // 表单校验
        rules: {
          realName: [
            { required: true, message: "姓名不能为空", trigger: "blur" }
          ],
          phone: [
            { required: true, message: "手机号不能为空", trigger: "blur" }
          ],
          email: [
            { required: true, message: "邮箱不能为空", trigger: "blur" },
            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
          ]
        }
     }
   },
   props: {
    tenantId: {
      type: Number,
      value: 0
    },
    username: {
      type: String,
      value: ''
    }
   },
   mounted() {
    console.log(this.tenantId);
    listKbWorkspaces_by_tenantId_username(this.tenantId, this.username).then(res => {
      console.log(res);
      this.kbWorkspaces = res.data;
      });
    this.$nextTick(() => {
    const testElements = [
      { font: '"PingFang SC"', text: '测试字体' },
      { font: '"Microsoft YaHei"', text: '测试字体' }
    ]

    testElements.forEach(({font, text}) => {
      const el = document.createElement('div')
      el.style.fontFamily = font
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      el.textContent = `${font} 渲染测试: ${text}`
      document.body.appendChild(el)
    })
  })
    console.log(this.tenantInfo);
    console.log(this.tenantId)
     this.refreshTable()
   },
   methods: {
    formatDate(cellValue) {
    return formatDate(cellValue);
  },
    refreshTable(){
        this.loading = true // 开始加载
        listKbWorkspaces_by_tenantId_username(this.tenantId, this.username).then(res => {
          this.kbWorkspaces = res.data
        }).finally(() => {
          this.loading = false // 结束加载
        })
    },
      /** 修改工作区配置提交按钮 */
      submitForm_settings: function() {
        //通过 ref 获取子组件实例并调用其 submitForm 方法
        this.$refs.settingComponent.submitForm();
      },
      handleSettingSubmit(result) {
        if (result) {
          this.$message.success("设置成功");
          this.open_setting = false;
          this.refreshTable(); // 刷新表格数据
        } else {
          this.$message.error("设置失败");
        }
      },
    HandleSetting(row) {
      console.log(row)
      this.currentSlug = row.slug
      this.title_setting = '知识库配置'
      this.open_setting = true
  },
      // 取消按钮
      cancel_setting() {
            this.open_setting = false;
            this.reset_setting();
    },
    reset_setting() {
      this.form_setting = {
        name:'',
        serviceTo: '',
      }
    },
    HandleDocument(row) {
      console.log(row)
       // 通过事件通知父组件切换标签和传递 slug
       this.$emit('tab-change', 'document', row.slug, row.name)
    },
  }
}
</script>

<style scoped>
/* 仪表盘样式 */
.dashboard-tab {
  padding: 0;
}

.tab-title {
  color: #333;
  margin-bottom: 25px;
  font-size: 1.5rem;
  font-weight: 500;
}

.info-text {
  color: #999;
  font-size: 1.2rem;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
}
/* 强制覆盖弹框内所有字体（最高优先级） */
body .el-dialog__wrapper .el-dialog .el-form-item__label,
body .el-dialog__wrapper .el-dialog .el-input__inner {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif !important;
}
.agent-img{
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.tips-container {
  display: flex;
  justify-content: left; /* 水平居中 */
  align-items: center;    /* 垂直居中 */
  height: 70px;          /* 容器高度设为视口高度 */
}
.empty-img{
  display: block;
  margin: 0 auto;
  opacity: 0.45;

}
.empty-text{
  color: #999;
}
.empty-container{
  width: 100%;
  text-align: center;
}
</style>